import { Inputs } from '../types/Enums';
import { FlowsQuestion } from '../types/FlowsTypes';

export const getFlowsDataTestId = (
  inputType: Inputs,
  question: FlowsQuestion | string,
  extraString?: string,
): string => {
  let questionId: string;
  if (typeof question === 'string') questionId = question;
  else questionId = question.id;

  const base = `FLOWS_${inputType}_${questionId
    .toUpperCase()
    .replaceAll('.', '-')}`;

  if (extraString) {
    return `${base}_${extraString}`;
  }

  return base;
};
